import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export const useDirection = () => {
  const { i18n } = useTranslation()

  useEffect(() => {
    const html = document.documentElement
    const lang = i18n.language
    const dir = lang === 'ar' ? 'rtl' : 'ltr'
    
    html.setAttribute('dir', dir)
    html.setAttribute('lang', lang)
  }, [i18n.language])
}

